import React, { createContext, useState, useEffect } from 'react';

export const PermisosContext = createContext({ permisos: [], setPermisos: () => { } });

export const PermisosProvider = ({ children }) => {
    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        const storedPermisos = JSON.parse(localStorage.getItem('permisos'));
        if (storedPermisos) {
            setPermisos(storedPermisos);
        }
    }, []);

    return (
        <PermisosContext.Provider value={{ permisos, setPermisos }}>
            {children}
        </PermisosContext.Provider>
    );
};